// extracted by mini-css-extract-plugin
export default {"personalized-advisor":"PersonalizedAdvisor_personalized-advisor__6fblK"};